import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Translation from '../../global/Translation';
import LocalizedLink from '../../global/LocalizedLink';
import { getSelectedCenter } from '../../../store/centers/reducers';
import { getLocalizedUrl } from '../../../store/ui/reducers';
import { changeCenter } from '../../../store/centers/actions';
import style from './style/small_banner_flash_promo_silestone_dekton_style.module.scss';

const mapStateToProps = state => ({
    localizedUrl: (intl, routeId, params = {}) => getLocalizedUrl(state, intl, routeId, params),
    selectedCenter: getSelectedCenter(state),
});

const mapDispatchToProps = dispatch => ({
    onChangeCenter: (centerId, urlCallback) => {
        dispatch({ type: 'CHANGE_CENTER_BY_USER', center: centerId });
        dispatch(changeCenter(centerId, urlCallback));
        dispatch({ type: 'REMEMBERED_CENTER' });
    },
});

const SmallBannerFlashPromoSilestoneDekton = (props) => {
    const { selectedCenter, localizedUrl, intl, onChangeCenter } = props;

    return (
        <div className={style['flash-promo']}>
            <div className={`${style['flash-promo__container']}`}>

                <span className={style['flash-promo__title']}>
                    <FormattedHTMLMessage id="flash_promo_silestone_dekton" defaultMessage="<b>FLASH PROMO</b> SILESTONE & DEKTON" />{' '}
                </span>

                <p className={style['flash-promo__subtitle']}>
                    <Translation id="eclos_priority_launch" defaultMessage="& ĒCLOS Priority Launch*" />
                </p>

                <p className={style['flash-promo__date']}>
                    <Translation id="march_9_13" defaultMessage="March 9th - 13th." />
                </p>

                <div className={style['flash-promo__card']}>
                    <div className={style['flash-promo__card-top']}>
                        <p className={style['flash-promo__discount']}>10%</p>
                        <div>
                            <p className={style['flash-promo__card-text']}>
                                <FormattedHTMLMessage
                                    id="off_on_1_2_or_full_truck"
                                    defaultMessage="OFF on 1/2 or <b>Full truck*</b>"
                                />
                            </p>
                            <p className={style['flash-promo__card-text']}>
                                <Translation id="of_silestone_dekton" defaultMessage="of Silestone/Dekton" />
                            </p>
                        </div>
                    </div>

                    <div className={style['flash-promo__divider']} />

                    <div className={style['flash-promo__card-note']}>
                        <div className={style['flash-promo__card-info']}>
                            <span>
                                <Translation id="full_truck_unlocks_exclusive_eclos_access" defaultMessage="*Full Truck unlocks exclusive ÉCLOS access" />
                            </span>
                        </div>

                        <div className={style['flash-promo__sub-info']}>
                            <span>
                                <Translation id="requirement_minimum_1_2_truckload_eclos_materials" defaultMessage="Requirement: Minimum 1/2 truckload of ÉCLOS materials." />
                            </span>
                        </div>

                        <div>
                            {selectedCenter == 1100 ? (
                                <LocalizedLink
                                    routeId="ROUTE_CATALOG"
                                    queryString="?type[0]=SLAB&brand[0]=ECLOS"
                                    params={{ outlet: '' }}
                                >
                                    <button className={style['flash-promo__link']}>
                                        <Translation id="discover_eclos" defaultMessage="Discover ÉCLOS" />
                                    </button>
                                </LocalizedLink>
                            ) : (
                                <button
                                    className={style['flash-promo__link']}
                                    onClick={() => {
                                        let baseUrl = localizedUrl(intl, 'ROUTE_CATALOG', { outlet: '' });
                                        while (baseUrl.endsWith('?')) {
                                            baseUrl = baseUrl.slice(0, -1);
                                        }
                                        const queryString = '?type[0]=SLAB&brand[0]=ECLOS';
                                        onChangeCenter(1100, `${baseUrl}${queryString}`);
                                    }}
                                >
                                    <Translation id="discover_eclos" defaultMessage="Discover ÉCLOS" />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className={`${style['flash-promo__footer']}`}>
                <span>
                    <Translation
                        id="please_note_that_discount_will_not_be_visible"
                        defaultMessage="Please note that discount will not be visible in your shopping cart, but will be reflected in your invoice."
                    />
                    {' '}
                </span>
                <span>
                    <Translation
                        id="this_discount_can_be_combined_with_other_current_promotions"
                        defaultMessage="This discount can be combined with other current promotions."
                    />
                    {' '}
                </span>
                <span>
                    <Translation
                        id="6_payment_terms"
                        defaultMessage="6 payment terms (30/60/90/120/150/180 days)"
                    />
                </span>
            </div>
        </div>
    );
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SmallBannerFlashPromoSilestoneDekton));